import * as React from "react";
import { Container } from "../../icons";
import { withVariationColors } from "../../colorVariations";
const SvgComponent = (
  { primaryColor, secondaryColor, title, titleId, fillColor, ...props },
  svgRef
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="none" fillRule="evenodd">
      <path
        fill={fillColor}
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.41-11.84l-5 5a.92.92 0 01-1.32 0l-2.82-2.81a.94.94 0 01.67-1.6.92.92 0 01.66.25l2.15 2.15 4.34-4.33a.933.933 0 111.32 1.32v.02z"
      />
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
);
const SvgVipIncludedMaterial = withVariationColors(
  ({ primaryColor, secondaryColor, fillColor, title, titleId, ...props }) => (
    <Container {...props}>
      <SvgComponent
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        fillColor={fillColor}
        title={title}
        titleId={titleId}
      />
    </Container>
  )
);
const MemoSvgVipIncludedMaterial = React.memo(SvgVipIncludedMaterial);
export default MemoSvgVipIncludedMaterial;
